export abstract class Constants {
  static readonly WORD_COUNT: number = 2313;
}
